document.addEventListener('DOMContentLoaded', function () {
  // Attach submit listener to all product forms
  document.querySelectorAll('form[action^="/cart/add"]').forEach((productForm) => {
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
     e.stopImmediatePropagation();
      const addToCartBtn = productForm.querySelector('.add-to-cart');
      if (!addToCartBtn) return;

      addToCartBtn.classList.add('loading');
      addToCartBtn.disabled = true;

      const formData = new FormData(productForm);
      const variantId = parseInt(formData.get('id'));
      const quantityToAdd = parseInt(formData.get('quantity'));
      const quantityInput = productForm.querySelector('.zquantity-input');
      const maxQty = parseInt(quantityInput?.getAttribute('max'));

      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartItem = cart.items.find(item => item.id === variantId);
        const currentQtyInCart = cartItem ? cartItem.quantity : 0;

        // console.log('Quantity to add:', quantityToAdd);
        // console.log('Current in cart:', currentQtyInCart);
        // console.log('Max allowed:', maxQty);

        if (currentQtyInCart + quantityToAdd > maxQty) {
          const errorDiv = productForm.querySelector('.max-qty-error');
          if (errorDiv) {
            errorDiv.innerText = `The maximum quantity of this product (${maxQty}) is already in your cart.`;
            errorDiv.style.display = 'block';

            // Hide the error after 5 seconds
            setTimeout(() => {
              errorDiv.innerText = '';
              errorDiv.style.display = 'none';
            }, 5000);
          } else {
            console.warn('⚠️ #max-qty-error element not found in form.');
          }

          addToCartBtn.classList.remove('loading');
          addToCartBtn.disabled = false;
          return;
        } else {
          const errorDiv = productForm.querySelector('#max-qty-error');
          if (errorDiv) {
            errorDiv.innerText = '';
            errorDiv.style.display = 'none';
          }
        }

        // ✅ Proceed with add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) throw new Error('Add to cart failed');

        await response.json();

        addToCartBtn.classList.remove('loading');
        addToCartBtn.classList.add('added');
        addToCartBtn.disabled = false;

        setTimeout(() => {
          addToCartBtn.classList.remove('added');
        }, 3000);

        // Refresh cart drawer
        const intervalId = setInterval(async () => {
          try {
            const res = await fetch('/cart.js');
            const cart = await res.json();

            updateCartItemCounts(cart.item_count);
            await updateCartDrawer();

            if (cart.item_count > 0) {
              OpenCartDrawer();
              scrollCartSidebarToBottom();
              document.dispatchEvent(new Event('cartSidebarOpened'));
              setTimeout(CloseCartDrawer, 3000);
              clearInterval(intervalId);
            }
          } catch (err) {
            console.error('Error updating cart drawer:', err);
            clearInterval(intervalId);
          }
        }, 1000);
      } catch (err) {
        console.error('❌ Add to cart error:', err);
        addToCartBtn.classList.remove('loading');
        addToCartBtn.disabled = false;
      }
    });
  });
});

function scrollCartSidebarToBottom() {
    setTimeout(() => {
        const cartSidebarForm = document.querySelector('.cart-sidebar-inner form');
        if (cartSidebarForm) {
            cartSidebarForm.scrollTop = cartSidebarForm.scrollHeight;
        }
    }, 300); // Delay allows sidebar content to fully render
}
